// src/components/HelpLink.js
// Small round "?" button that opens a documentation page (docs site, new tab).
// Plain <a target="_blank">, not the router <Link>: the docs are a separate site.
import React from 'react';
import { docsLink } from '../constants/docsLinks';
import './HelpLink.css';

const HelpLink = ({ path, title = 'Open documentation', className = '' }) => (
  <a
    href={docsLink(path)}
    target="_blank"
    rel="noopener noreferrer"
    className={`help-link ${className}`}
    title={title}
    aria-label={title}
    onClick={(e) => e.stopPropagation()}
  >
    <i className="bi bi-question-lg" aria-hidden="true"></i>
  </a>
);

export default HelpLink;
